import classNames from 'classnames';
import React from 'react';

import {CrumbLink} from 'ui-library/Breadcrumbs';
import {getWorkflowDisplayString} from 'workflows/util/WorkflowUtil';

import * as WorkflowActions from '../WorkflowActions';

export function WorkflowsCrumbLink(props: WorkflowsCrumbLinkProps): JSX.Element {
  return (
    <CrumbLink
      className={classNames(props.className, 'legacy-font-proxima-subtitle')}
      onClick={() => {
        WorkflowActions.openWorkflowDashboardScreen();
      }}
    >
      {getWorkflowDisplayString('Legacy Workflows', 'Workflows')}
    </CrumbLink>
  );
}

interface WorkflowsCrumbLinkProps {
  className?: string;
}

export function WorkflowTemplatesCrumbLink(): JSX.Element {
  return (
    <CrumbLink
      className="workflows-workflowHeader-workflowTemplatesCrumbLink"
      onClick={() => {
        WorkflowActions.openWorkflowDashboardTemplatesScreen();
      }}
    >
      Templates
    </CrumbLink>
  );
}
